module.exports = __webpack_public_path__ + "img/2025-10-15d_4.69baa4bc.jpg";